module.exports = __webpack_public_path__ + "img/wechatGrey.2f74f770.svg";